const PERCENTAGE_MAX_VALUE = 100;

export const isPercentageAboveMaximum = (value: unknown): boolean => {
  const parsed = parsePercentageValue(value);
  return parsed !== undefined && parsed > PERCENTAGE_MAX_VALUE;
};

export const parsePercentageValue = (value: unknown): number | undefined => {
  const raw = String(value ?? '').trim();
  if (!raw) return undefined;

  const normalized = raw.includes(',')
    ? raw.replace(/\./g, '').replace(',', '.')
    : raw;

  const parsed = Number(normalized);
  return Number.isFinite(parsed) ? parsed : undefined;
};

export const formatPercentageValue = (value: unknown): string => {
  const parsed = parsePercentageValue(value);
  if (parsed === undefined) return '';

  return parsed.toLocaleString('pt-BR', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  });
};

export const maskPercentageValue = (value: unknown): string => {
  const raw = String(value ?? '').replace('.', ',').replace(/[^\d,]/g, '');
  if (!raw) return '';

  if (raw.includes(',')) {
    const [integerRaw, ...decimalParts] = raw.split(',');
    const integer = integerRaw.replace(/\D/g, '').slice(0, 3);
    const decimal = decimalParts.join('').replace(/\D/g, '').slice(0, 2);
    return `${integer}${raw.endsWith(',') || decimal ? ',' : ''}${decimal}`;
  }

  const digits = raw.replace(/\D/g, '').slice(0, 5);
  if (digits.length <= 2) return digits;

  if (digits === '100') return '100';

  if (digits.length === 3) return `${digits.slice(0, 2)},${digits.slice(2)}`;

  if (digits.startsWith('100')) {
    return `${digits.slice(0, 3)}${digits.length > 3 ? `,${digits.slice(3, 5)}` : ''}`;
  }

  return `${digits.slice(0, -2)},${digits.slice(-2)}`;
};
